import type { IconProps } from './types';
import './icons.css';

export default function DoubleArrowLeft({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      className={`icon icon-double-arrow-left ${className || ''}`}
      fill="none"
    >
      <path stroke="currentColor" d="m16 6-4 4.5 4 4.5M9 6l-4 4.5L9 15" />
    </svg>
  );
}
